import React, { Component } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import Impersonation from "./containers/Impersonation/Impersonation";
import Login from "./containers/Login/Login";
import RoutePath from "./containers/RoutePath/RoutePath";

interface IStatefromProps {
  token: string;
}
interface IDispatchFromProps {}

type Props = IStatefromProps & IDispatchFromProps & RouteComponentProps;
class App extends Component<Props> {
  state = {
    accessTokenAvailable: sessionStorage.getItem(`token`),
    impersonate:sessionStorage.getItem('impersonate')
  };
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  componentDidUpdate(prevProps) {}
  componentDidMount() {
    if (
      this.props.location.search.split("?")[1]?.split("=")[0].toLowerCase() ===
        "id_token" && !localStorage.getItem("linkClicked")
    ) {
      this.setState({ linkClicked: false });
      sessionStorage.setItem(
        "token",
        this.props.location.search.split("?")[1].split("=")[1]
      );
      this.props.history.replace("/home");
      this.setState({ accessTokenAvailable: true });
    }
  }
  render() {
    return this.state.impersonate != null?<Impersonation/>:(this.state.accessTokenAvailable ? <RoutePath /> : <Login />)
  }
}
const mapStateToProps = (state: any) => ({
  token: state.fetchAccessToken.token,
});
export default connect(mapStateToProps)(withRouter(App));
